module.exports = __webpack_public_path__ + "static/media/Health-based-Level04.599d99d9.svg";